import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS } from "@/data/content";
import { Reveal, SectionLabel } from "@/components/Reveal";

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section data-testid="faq-section" className="mx-auto max-w-[1500px] px-6 py-24 md:px-12 md:py-36 lg:px-24">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <SectionLabel>Questions fréquentes</SectionLabel>
            <h2 className="mt-6 font-serif text-4xl font-light leading-tight tracking-tight sm:text-5xl">
              Ce que l'on me demande souvent
            </h2>
            <p className="mt-6 max-w-sm text-deep/60">
              Une autre question ? Écrivez-moi, il me fera plaisir de vous répondre.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            {FAQS.map((f, i) => (
              <div key={i} className="border-b border-deep/10" data-testid={`faq-item-${i}`}>
                <button
                  data-testid={`faq-question-${i}`}
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="group flex w-full items-center justify-between gap-6 py-7 text-left"
                >
                  <span className="font-serif text-xl leading-snug text-deep transition-colors duration-300 group-hover:text-sage-dark md:text-2xl">
                    {f.q}
                  </span>
                  <Plus
                    className={`h-5 w-5 shrink-0 text-gold transition-transform duration-500 ${
                      open === i ? "rotate-45" : ""
                    }`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p data-testid={`faq-answer-${i}`} className="max-w-2xl pb-7 leading-relaxed text-deep/60">
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
